module.exports = __webpack_public_path__ + "static/media/pipeline_dark.dfe89931.png";